import {
    Box,
    Button,
    Flex,
    Heading,
    Text,
    Card,
    CardBody,
    CardFooter,
    Stack,
    HStack,
    Image
} from '@chakra-ui/react'
import { CheckoutsType, useTakeoutChild } from '@/modules/teacher/hooks/useCheckoutQueue'

type QueueCardProps = {
    details: CheckoutsType
}

function QueueCard({ details }: QueueCardProps) {
    const { takeoutChild, loading, error } = useTakeoutChild()

    if (error) {
        return <Text color="tomato">{error.message}</Text>
    }

    return (
        <Card maxW={'lg'} mt={2} variant={'outline'}>
            <CardBody>
                {details.child ? (
                    <Flex flex="1" gap="4" direction={'column'}>
                        <Image
                            borderRadius={6}
                            minW={'120px'}
                            maxH={'240px'}
                            objectFit="cover"
                            src={details.child?.picture}
                            alt={`${details.child.firstName}`}
                            fallbackSrc="https://via.placeholder.com/150"
                        />
                        <Box>
                            <Heading fontSize="lg">
                                {details.child.firstName} {details.child.lastName}
                            </Heading>
                            <Text>{details.child.ageGroup}</Text>
                        </Box>
                    </Flex>
                ) : null}

                <HStack justifyContent={'space-between'} pt={4}>
                    <Stack gap={2}>
                        <Heading color="gray.600" fontWeight={'normal'} size="xs">
                            Check-in
                        </Heading>
                        {details.checkedInParentBy ? (
                            <Flex flex="1" gap="4" alignItems="center" flexWrap="wrap">
                                <Box>
                                    <Text
                                        fontWeight={'bold'}
                                        size="sm"
                                    >{`${details.checkedInParentBy?.firstName} ${details.checkedInParentBy.lastName}`}</Text>
                                    <Text
                                        fontSize="sm"
                                        color="gray"
                                    >{`${details.checkedInParentBy?.relationship}`}</Text>
                                </Box>
                            </Flex>
                        ) : null}
                    </Stack>
                    <Stack gap={2}>
                        <Heading color="gray.600" fontWeight={'normal'} size="xs">
                            Checkout
                        </Heading>
                        {details.checkedOutParentBy ? (
                            <Flex flex="1" gap="4" alignItems="center" flexWrap="wrap">
                                <Box>
                                    <Text
                                        fontWeight={'bold'}
                                        size="sm"
                                    >{`${details.checkedOutParentBy?.firstName} ${details.checkedOutParentBy.lastName}`}</Text>
                                    <Text
                                        fontSize="sm"
                                        color="gray"
                                    >{`${details.checkedOutParentBy?.relationship}`}</Text>
                                </Box>
                            </Flex>
                        ) : null}
                    </Stack>
                </HStack>
            </CardBody>
            <CardFooter>
                {details.child ? (
                    <Button
                        size="lg"
                        w={'full'}
                        colorScheme="gray"
                        aria-label="Take out"
                        onClick={() => {
                            takeoutChild({
                                variables: {
                                    childId: details.child?._id
                                }
                            })
                        }}
                        isLoading={loading}
                        loadingText="Submitting"
                    >
                        Bring out child
                    </Button>
                ) : null}
            </CardFooter>
        </Card>
    )
}

export default QueueCard
